import React, { Component } from 'react';
import './VirtualCommencementSelector.scss';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import filter from 'lodash/filter';
import Grid from '@material-ui/core/Grid';
declare var jQuery: any;
class VirtualCommencementSelector extends Component {


	constructor(props) {
		super(props);
		this.state = {
			selected:false
		}
		this.onChange = this.onChange.bind(this);
	}

  	componentDidMount() {
  		
	}    
	onChange(evt, value) {
		let selection = filter(window.virtualCommencementData, (item,key) => {
			return item['Full Name'] == value;
		});
		if(selection.length) { 
			this.setState({ selected: selection});
		} else {
			this.setState({ selected: false});
		}
	}
  	render() {
  		let goBTN = null;
  		if(this.state.selected) {
  			goBTN = (<a href={this.state.selected[0].LINK} target="_blank" className="go-btn">GO</a>);
  		}
  		return (<div>
  		<Grid container alignItems="center"
  justify="center" spacing={3}>
        	<Grid item xs={10}>
	  			<Autocomplete className="virtual-commencement-search-by-user"
			        id="free-solo-demo"
			        onChange={this.onChange}
			        options={window.virtualCommencementData.map((option) => option['Full Name'])}
			        renderInput={(params) => (
			          <TextField {...params} label="Search by Full Name" margin="normal" variant="outlined" />
			        )}
			      />
			</Grid>
			<Grid item xs={2}>
		    {goBTN}
		    </Grid>
		</Grid>
  		</div>);	
  	}
}

VirtualCommencementSelector.propTypes = {

};

export default VirtualCommencementSelector;










// WEBPACK FOOTER //
// ./src/VirtualCommencementSelector/VirtualCommencementSelector.js